import React, { useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import { connect } from 'react-redux'

import {setApp, clearState, setUdn} from "../../../redux/actions/generalActions/mainActions";
import { showLoader } from "../../../components/loader/loader";
import PathCanvas from "./_canvas";

const PathMap = props => {
    const { viewMode, loading } = props.mainProps

    useEffect(() => {
        return () => {
            props.clearState();
        }
    }, []);

    useEffect(() => {
        const udn = localStorage.getItem('selectedUdn') !== '' ? JSON.parse(localStorage.getItem('selectedUdn')) : null

        if (udn !== null)
            props.setUdn(udn);

        if (props.app !== null)
            props.setApp(props.app);
    },[ ]);

    return (
        <>
            { loading ? showLoader() : null}
            <Row>
                <Col md="12">
                    {(
                        function() {
                            switch (viewMode) {
                                case "LIST" :
                                    return <PathCanvas />
                                default:
                                    return null;
                            }
                        })()}
                </Col>
            </Row>
        </>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setUdn,
    setApp
});

export default connect(mapStateToProps, mapActionsToProps)(PathMap)